import { initializeTheme as initTheme, getTheme } from '../design-system/theme-config';

/**
 * Initialize the theme by injecting CSS variables into the document root
 * This function should be called as early as possible in the app initialization
 *
 * Now uses the centralized theme-config.ts for white-labeling support
 */
export function initializeTheme(): void {
  initTheme();
}

/**
 * Get the current theme name
 */
export function getCurrentThemeName(): string {
  return getTheme().name;
}